import { render, staticRenderFns } from "./Fecha.vue?vue&type=template&id=47c08046&scoped=true&"
import script from "./Fecha.vue?vue&type=script&lang=js&"
export * from "./Fecha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c08046",
  null
  
)

export default component.exports